import { useEffect, useState } from "react";
import SelectComponent from "../../components/SelectComponent";
import InputComponent from "../../components/InputComponent";
import CheckBoxComponent from "../../components/CheckBoxComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toastComponent } from "../../components/ToastComponent";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { createleadPreference, getLeadPreference, placeOrder } from "../../redux/features/leadUserCart/leadUserCart";
import backArrow from "../../assets/icons/up arrow.svg";
import { nanoid } from "nanoid";
import successOutline from "../../succcess-outline-icon.svg";

type Props = {};

const UserCatalogueForm = (props: Props) => {
  const [isView, setIsView] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const screwTypeArr = [
    { id: 1, name: "Bombay Post with Screw" },
    { id: 2, name: "Bombay Post without Screw" },
    { id: 3, name: "South Screw" },
    { id: 4, name: "Push Butterfly Screw" },
  ];

  const navigate = useNavigate();

  const default_user_preference = useAppSelector((res) => res.leadUserCart.default_user_preference);
  const karatVal = useAppSelector((state) => state.leadUserCatalogue.karatid);
  const addedToCartArr = useAppSelector((state) => state.leadUserCart.row);
  const addedToCart = addedToCartArr[0]?.list[0]?.karat;
  const schema = yup.object().shape({
    // screw_type: yup.string().required("Please select Screw type"),
    karat: yup.string(),
    order_remark: yup.string(),
  });

  const {
    control,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      // @ts-ignore
      screw_type: default_user_preference.screw_type,
      // @ts-ignore
      karat: addedToCart,
      // @ts-ignore
      order_remark: default_user_preference.order_remark,
    },
  });
  useEffect(() => {
    Object.values(errors)
      .slice(0, 1)
      .map((element: any) => {
        toastComponent(element.message, "error");
      });
  }, [errors]);

  useEffect(() => {
    // @ts-ignore
    setValue("screw_type", default_user_preference?.screw_type);
    // @ts-ignore
    setValue("karat", addedToCart);
    // @ts-ignore
    setValue("order_remark", default_user_preference?.order_remark);
  }, [default_user_preference]);

  const watchee = watch();
  const dispatch = useAppDispatch();

  async function onSubmit(data: any) {
    setIsSubmitting(true);
    try {
      const preferenceRes = await dispatch(createleadPreference({ ...data, color_same_selected: data?.color_same_selected ? 1 : 0 }));

      if (preferenceRes.payload.success === true) {
        const orderRes = await dispatch(
          placeOrder({
            screw_type: data?.screw_type,
            karat: data?.karat,
            final_order_remark: data?.order_remark,
          })
        );

        if (orderRes.payload.success === true) {
          toastComponent(orderRes.payload.message, "success");
          setIsView(false);
        } else {
          toastComponent("Failed to place order", "error");
        }
      } else {
        toastComponent("Failed to save preferences", "error");
      }
    } catch (error) {
      toastComponent("An error occurred while processing your order", "error");
    } finally {
      setIsSubmitting(false);
    }
  }

  useEffect(() => {
    if (isView === false) {
      setTimeout(() => {
        navigate(`/catalogues/${id}`);
      }, 5000);
    }
  }, [isView]);

  useEffect(() => {
    dispatch(getLeadPreference());
  }, []);

  const { id } = useParams();

  return (
    <>
      <div className={isView ? "text-primary min-h-screen bg-gray-50" : "min-h-[90vh] text-primary flex flex-col bg-gray-50"}>
        {isView ? (
          <div className="container mx-auto px-4 py-8 max-w-4xl">
            {/* Header */}
            <div className="mb-8">
              <Link to={`/catalogues/${id}/order-cart`} className="flex flex-row items-center text-primary hover:text-primary-dark transition-colors">
                <img src={backArrow} alt="" className="-rotate-90 h-4 w-4 mr-2" />
                <span className="font-medium">Back to Cart</span>
              </Link>
            </div>

            {/* Karat Selection */}
            {/* <div className="bg-white rounded-xl shadow-sm p-6 mb-8">
              <h2 className="text-xl font-bold mb-4">Selected Karat</h2>
              <div className="flex flex-wrap gap-3">
                {[14, 18, 20, 22].map((i) => (
                  <div key={nanoid()} className="cursor-not-allowed">
                    <span className={`border-2 py-2 px-4 rounded-lg font-medium transition-colors ${
                      i === addedToCart 
                        ? "bg-primary text-white border-primary" 
                        : "bg-gray-100 text-gray-400 border-gray-200"
                    }`}>
                      {i}K
                    </span>
                  </div>
                ))}
              </div>
            </div> */}

            {/* Order Form */}
            <div className="bg-white rounded-xl shadow-sm p-8">
              <h2 className="text-2xl font-bold mb-6">Order Details</h2>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div style={{ display: "none" }}>
                  <SelectComponent
                    cataSelect={false}
                    inputRef="screw_type"
                    data={screwTypeArr}
                    asterisk={true}
                    placeHolder="Bombay Post with Screw"
                    label="Screw Type"
                    control={control}
                  />
                </div>

                <div>
                  <InputComponent placeHolder="Type here" label="Final Order Remarks" inputRef="order_remark" register={register} />
                </div>

                <div className="flex flex-col sm:flex-row gap-4 pt-6">
                  <ButtonComponent CTA="Cancel" variant="dynamic" onClick={() => navigate(`/catalogues/${id}/order-cart`)} style={{ flex: 1 }} />
                  <ButtonComponent
                    CTA={isSubmitting ? "Processing..." : "Submit & Place Order"}
                    variant="primary"
                    buttonType="submit"
                    disabled={isSubmitting}
                    style={{
                      flex: 1,
                    }}
                  />
                </div>
              </form>
            </div>
          </div>
        ) : (
          <div className="h-full m-auto flex items-center justify-center">
            <div className="text-center max-w-md mx-auto px-4">
              <div className="mb-8">
                <img src={successOutline} alt="Order placed successfully" className="mx-auto w-64 h-64 object-contain" />
              </div>
              <h1 className="text-3xl font-bold text-primary mb-4">Congratulations!</h1>
              <p className="text-xl text-gray-600 mb-2">Your order has been placed successfully!</p>
              <p className="text-gray-500">Our executive will contact you asap.</p>
              <div className="mt-8">
                <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto"></div>
                <p className="text-sm text-gray-500 mt-4">Redirecting to catalogue...</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default UserCatalogueForm;
